import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { AppFilter } from '@app/shared/models';
import { UserMgtServiceService } from '../services/user-mgt-service.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-user-management',
  templateUrl: './user-management.component.html',
  styleUrls: ['./user-management.component.scss'],
})
export class UserManagementComponent implements OnInit {
  filter: AppFilter = new AppFilter();
  pending: boolean;
  rows: number = 2;
  currentPage: number = 1;
  maxSize: number = 7;
  users: Array<any> = [];
  success: any;
  totalUsers: number;
  totalBlockedUsers: number;
  totalRecentlyLoggedInUsers: number;
  error: any;

  constructor(private router: Router, private userSvc: UserMgtServiceService) {
    // this.getAllUsers();
    // this.getAllBlocledUsers();
    // this.getRecentLoggedInUsers();
  }

  ngOnInit(): void {}

  goBack() {
    this.router.navigate(['/admin/setting/application-security']);
  }

  getAllUsers() {
    this.filter.page = 1;

    this.userSvc
      .getAllUsers({
        params: this.filter,
      })
      .subscribe(
        (res) => {
          this.totalUsers = +res['records'];
          // this.users = res['rows'];
        },
        (error) => {
          this.error = error.error ? error.error : error;
        }
      );
  }

  getAllBlocledUsers() {
    this.filter.page = 1;

    this.userSvc
      .getBlockedUsers({
        params: this.filter,
      })
      .subscribe(
        (res) => {
          this.totalBlockedUsers = +res['records'];
          // this.users = res['rows'];
        },
        (error) => {
          this.error = error.error ? error.error : error;
        }
      );
  }

  getRecentLoggedInUsers() {
    this.filter.page = 1;
    this.userSvc
      .getRecentlyLoggedInUsers({
        params: this.filter,
      })
      .subscribe(
        (res) => {
          this.totalRecentlyLoggedInUsers = +res['records'];
        },
        (error) => {
          this.error = error.error ? error.error : error;
        }
      );
  }
}
